import React from 'react'
import classNames from 'classnames'
import { WemoloTypography } from '../../components/Wemolo'
import styles from './LotList.module.css'

interface LotListProps {
    label: string
    lots: string[]
    variant?: 'default' | 'error'
    emptyMessage?: string
    onRemove?: (lot: string) => void
    showRemoveButton?: boolean
    rightAction?: React.ReactNode
    className?: string
}

export const LotList: React.FC<LotListProps> = ({
    label,
    lots,
    variant = 'default',
    emptyMessage,
    onRemove,
    showRemoveButton = true,
    rightAction,
    className
}) => {
    const isError = variant === 'error'

    return (
        <div className={classNames(styles.root, className)}>
            <div className={styles.header}>
                <label className={classNames(styles.label, { [styles.error]: isError })}>
                    <WemoloTypography variant="body-medium-emphasized" tag="span">
                        {label}
                    </WemoloTypography>
                </label>
                {rightAction}
            </div>
            <div className={classNames(styles.list, { [styles.error]: isError })}>
                {lots.length > 0 ? (
                    lots.map((lot, index) => (
                        <div key={`${lot}-${index}`} className={classNames(styles.chip, { [styles.error]: isError })}>
                            <WemoloTypography variant="body-small" tag="span">
                                {lot}
                            </WemoloTypography>
                            {showRemoveButton && onRemove && (
                                <button
                                    onClick={() => onRemove(lot)}
                                    className={styles.removeButton}
                                    aria-label={`Remove ${lot}`}
                                >
                                    ×
                                </button>
                            )}
                        </div>
                    ))
                ) : emptyMessage ? (
                    <span className={styles.emptyMessage}>
                        <WemoloTypography variant="body-small" tag="span">
                            {emptyMessage}
                        </WemoloTypography>
                    </span>
                ) : null}
            </div>
        </div>
    )
}
